module.exports = __webpack_public_path__ + "img/company-manage.cea602d3.svg";